import { useState } from "react";
import { PRESETS, presetRange } from "./dashboard/PeriodBar";

const sel = "rounded-md border border-zinc-800 bg-zinc-900/50 px-3 py-2 text-sm text-slate-200 outline-none focus:border-[#C5A059]/60";

export function usePeriod(defaultPreset = "this_month", storageKey = null) {
  const saved = storageKey ? (() => { try { return JSON.parse(localStorage.getItem(storageKey) || "null"); } catch { return null; } })() : null;
  const [period, setPeriodRaw] = useState(() => saved?.preset === "custom" && saved.start && saved.end
    ? saved : { preset: saved?.preset && PRESETS[saved.preset] ? saved.preset : defaultPreset, ...presetRange(saved?.preset && PRESETS[saved.preset] ? saved.preset : defaultPreset) });
  const setPeriod = (fn) => setPeriodRaw((p) => { const n = typeof fn === "function" ? fn(p) : fn; if (storageKey) localStorage.setItem(storageKey, JSON.stringify(n)); return n; });
  return [period, setPeriod, { start: period.start, end: period.end }];
}

export function periodLabel(period) {
  return period.preset === "custom"
    ? `${new Date(period.start).toLocaleDateString("it-IT")} → ${new Date(period.end).toLocaleDateString("it-IT")}`
    : PRESETS[period.preset].toLowerCase();
}

export default function PeriodSelect({ period, setPeriod, testid = "filter-period", small = false }) {
  const cls = small ? `${sel} px-2 py-1 text-xs` : sel;
  const setPreset = (v) => setPeriod((p) => ({ ...p, preset: v, ...(presetRange(v) || {}) }));
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`${testid}-wrap`}>
      <select data-testid={testid} value={period.preset} onChange={(e) => setPreset(e.target.value)} className={cls}>
        {Object.entries(PRESETS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
      </select>
      {period.preset === "custom" && (
        <>
          <input type="date" value={period.start} data-testid={`${testid}-start`} max={period.end} onChange={(e) => setPeriod((p) => ({ ...p, start: e.target.value }))} className={cls} />
          <span className="text-slate-500">→</span>
          <input type="date" value={period.end} data-testid={`${testid}-end`} min={period.start} onChange={(e) => setPeriod((p) => ({ ...p, end: e.target.value }))} className={cls} />
        </>
      )}
    </div>
  );
}
